import React, { useContext, useEffect } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import {
	ICreateSubcategoryModalContext,
	CreateSubcategoryModalContext,
} from '../../../../../../../../createSubcategoryModalContext/createSubcategoryModalState/createSubcategoryModalContext';
import { NameSubCategoryInput } from './components/NameSubCategoryInput';
import { CategorySelect } from './components/CategorySelect';
import { SendBtn } from './components/SendBtn';
import axios from 'axios';
import { Form } from 'antd';
import { ServerErrorTypes } from 'types';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { createSubcategoryV2 } from 'backend/subcategories';

export const InputFields: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const {
		changeTypeOfModalWindow,
		showErrorModalWithInfo,
		fileId,
		IDCustomer,
		IDRestaurant,
		nameOfSubCategory,
		IDSelectedCategory,
		isHiddenSubCategory,
		isAvailableForRepetition,
		defaultCustomerLanguage,
		translations,
	} = useContext<ICreateSubcategoryModalContext>(CreateSubcategoryModalContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			nameOfSubCategory,
			IDSelectedCategory,
			isHiddenSubCategory,
			isAvailableForRepetition,
		});
	}, [nameOfSubCategory, IDSelectedCategory, isHiddenSubCategory, isAvailableForRepetition]);

	const submit = async () => {
		const defaultTranslationIsEmpty =
			translations.find((translation) => translation.languageId === defaultCustomerLanguage?.id)?.name === '';
		if (defaultTranslationIsEmpty) {
			changeTypeOfModalWindow('defaultTranslationIsEmpty');
			return;
		}

		changeTypeOfModalWindow(null);
		try {
			showLoader();
			await createSubcategoryV2({
				fileId: fileId,
				name: nameOfSubCategory,
				customerId: IDCustomer || '',
				restaurantIds: [IDRestaurant || ''],
				categoryId: IDSelectedCategory || '',
				overrideScheduleAvailability: false,
				activationCron: null,
				deactivationCron: null,
				translations,
			});
			changeTypeOfModalWindow('success');
		} catch (err) {
			if (
				axios.isAxiosError(err) &&
				err.response?.data.Type === ServerErrorTypes.SUB_CATEGORY_VALIDATION_FAILED
			) {
				showErrorModalWithInfo(err.response.data);
			} else {
				changeTypeOfModalWindow('error');
			}
		} finally {
			hideLoader();
		}
	};

	return (
		<div className="flex-1 relative" data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<NameSubCategoryInput />
				<CategorySelect />
				<SendBtn />
			</Form>
		</div>
	);
};
